import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./fonts/shyest-regular.otf%22,%22display%22:%22swap%22,%22variable%22:%22--font-shyest%22,%22preload%22:true}],%22variableName%22:%22shyest%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'shyest', 'shyest Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
